<div fxFlex fxLayout="row" class="mat-form-field">
    <mat-select [formControl]="resourceFormControl" [multiple]="multiple">
      <mat-option>
        <ngx-mat-select-search
          *ngIf="resources.length > 1"
          [formControl]="resourceFilterControl"
          [placeholderLabel]="'common.search' | translate"
          [noEntriesFoundLabel]="
            'resources-selector.no-matching-resources' | translate
          "
        ></ngx-mat-select-search>
      </mat-option>

      <mat-option *ngIf="!multiple && !required" [value]="null">
        {{ 'common.none' | translate }}
      </mat-option>

      <ng-container *ngIf="groupByType; else withoutGroups">
        <ng-container *ngFor="let entry of filteredGroupResources$ | async | keyvalue">
          <mat-optgroup [label]="entry.key | titlecase">
            <ng-container *ngFor="let resource of entry.value">
              <mat-option [value]="resource.id">{{ resource.name }}</mat-option>
            </ng-container>
          </mat-optgroup>
        </ng-container>
      </ng-container>

      <ng-template #withoutGroups>
        <mat-option *ngFor="let resource of filteredResources$ | async" [value]="resource.id">
          {{ resource.name }}
        </mat-option>
      </ng-template>
    </mat-select>
  </div>